<template>
	<div class="region">
		<button class="btn btn-plain trigger" v-click-outside="hide" @click="toggle">
<!--			<svg class="ticon"><use xlink:href="/images/icons.svg#icon-globe"></use></svg>-->
			<template v-if="region === '1'">
				<img class="ticon" src="/images/Eur.svg" alt="EUR"/>
			</template>
			<template v-if="region === '2'">
				<img class="ticon" src="/images/Usd.svg"  alt="USD" />
			</template>
		</button>
		<div class="list" v-show="opened" ref="region_list">
			<ul class="list-unstyled">
				<li v-for="region in regions">
					<a :href="region.url" :title="region.title" v-text="region.title === 'Europe' ? $__('site.region.europe') + ' (€)' : $__('site.region.usa') + ' ($)'" @click.prevent="saveRegion(region.id)"></a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
	name: 'Region',
	data() {
		return {
			opened: false,
			region: false,
		}
	},
	props: {
		regions: Array|Object
	},
	computed: {

	},

	methods: {
		saveRegion(region, e) {
			this.hide()
			axios.post('/api/region', {region: region})
				.then(response => {
					if (response.data.error === false) {
						localStorage.setItem('lupit_selected_region', region);
						document.cookie = `lupit_selected_region=${region}; path=/; max-age=${7 * 24 * 60 * 60}; SameSite=lax`;
						location.reload()
					}
				})
				.catch(function (error) {
					// error
				})
		},
		toggle() {
			this.opened = true
			this.$refs.region_list.classList.add('active')
		},

		hide() {
			this.opened = false
			this.$refs.region_list.classList.remove('active')
		}
	},

	mounted () {
		this.region = localStorage.getItem('lupit_selected_region');
		// prevent click outside event with popupItem.
		this.popupItem = this.$el
	},
	directives: {
		ClickOutside
	}
}
</script>
